export const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
export const UPPERCASE = 'ABCDEFGHJKLMNOPQRSTUVWXYZ';
export const DIGITS = '0123456789';
export const LETTERS = LOWERCASE.concat(UPPERCASE);
export const LETTERS_DIGITS = LETTERS.concat(DIGITS);
export const LOWERCASE_DIGITS = LOWERCASE.concat(DIGITS);
export const LETTERS_DIGITS_UNDERSCORE = LETTERS_DIGITS.concat('_');
export const LETTERS_DIGITS_UNDERSCORE_DOT_DASH = LETTERS_DIGITS_UNDERSCORE.concat('.-');
export const LOWERCASE_DIGITS_UNDERSCORE = LOWERCASE_DIGITS.concat('_');
export const SPECIALS_TO_UNDERSCORE = [
  ['!', '_'],
  ['@', '_'],
  ['#', '_'],
  ['$', '_'],
  ['%', '_'],
  ['^', '_'],
  ['&', '_'],
  ['*', '_'],
  ['(', '_'],
  [')', '_'],
  ['+', '_'],
  ['/', '_'],
  ['{', '_'],
  ['}', '_'],
  ['~', '_'],
  [' ', '_'],
  ['.', '_'],
  [',', '_'],
  ['<', '_'],
  ['>', '_'],
];
export const SPECIALS_TO_UNDERSCORE_NO_DOT = [
  ['!', '_'],
  ['@', '_'],
  ['#', '_'],
  ['$', '_'],
  ['%', '_'],
  ['^', '_'],
  ['&', '_'],
  ['*', '_'],
  ['(', '_'],
  [')', '_'],
  ['+', '_'],
  ['/', '_'],
  ['{', '_'],
  ['}', '_'],
  ['~', '_'],
  [' ', '_'],
  [',', '_'],
  ['<', '_'],
  ['>', '_'],
];
export const SPACES_TO_UNDERSCORE = [
  [' ', '_'],
];

export const PHONETICS = [
  ['aɪr', 'air'],
  ['tʃ', 'ch'],
  ['dʒ', 'dzh'],
  ['ɪr', 'ir'],
  ['ɛr', 'er'],
  ['ɑr', 'ar'],
  ['ɔr', 'or'],
  ['ɔɪ', 'oi'],
  ['aʊ', 'au'],
  ['aɪ', 'ai'],
  ['oʊ', 'oh'],
  ['eɪ', 'ei'],
  // ['i', 'tense_i'],
  ['ɪ', 'lax_i'],
  ['ɛ', 'e'],
  ['æ', 'ae'],
  ['ə', 'schwa'],
  ['ʌ', 'uh'],
  ['ɑ', 'a'],
  // ['u', 'tense_u'],
  ['ʊ', 'lax_u'],
  ['ɔ', 'o'],
  ['ɝ', 'ur'],
  ['ɚ', 'schwar'],
  ['ɡ', 'g'],
  ['θ', 'voiceless_th'],
  ['ð', 'voiced_th'],
  ['ʃ', 'sh'],
  ['ʒ', 'zh'],
  ['ŋ', 'ng'],
  // ['j', 'yod'],
  ['t̬', 'flap_t'],
  ['ʔ', 'glottal_t'],
  ['ɫ', 'dark_l'],

  ['/i/', 'tense_i'],
  ['/u/', 'tense_u'],
  ['/j/', 'yod'],
];

export function validateString(s: string, allowed = '', replace: string[][] = [], lowercase = true): string {
  let str = s;
  replace.forEach((replaceStr) => {
    str = str.replaceAll(replaceStr[0], replaceStr[1]);
  });
  if (replace || allowed) {
    if (lowercase) str = str.toLowerCase();
    str = str.trim();
  }
  if (allowed !== '') {
    let newStr = str;
    for (let i = 0; i < str.length; i += 1) {
      if (!allowed.includes(str[i])) {
        newStr = newStr.replaceAll(str[i], '');
      }
    }
    str = newStr;
  }
  return str;
}
